// https://vuex.vuejs.org/en/state.html

export default {
  orgs: [],
  users: [],
  vehiType: [],
  contactContext: null,
  goToken: false,
  driverHoursProviderName: false,
  telematicsProviderName: false,
  driverHoursProviderUrl: false,
  telematicsProviderUrl: false,
  DashBoardUserId: false,
  quickSearchResults: {},
  quickSearchPayload: {},
  serviceList: [],
  currentUser: {}
}
